<!-- Banner -->
<div *ngFor="let m of Messages">
  <mat-card [id]="m.id" class="{{m.style}}">
    <mat-card-content fxLayout="row" fxLayoutAlign="space-between center">
      <div [innerHTML]="m.htmlBody">
      </div>
      <button *ngIf="m.onClearBanner" mat-icon-button (click)="m.onClearBanner()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-content>
  </mat-card>
</div>
